module.exports = __webpack_public_path__ + "9c4dd7ffd1fc791d30de6aee70c02bc3.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/john-feminella.jpg
// module id = 443
// module chunks = 0